export default __webpack_public_path__ + "static/media/GOJELLY_Logo_simple_v01.92f048f6.svg";